import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import { Tile } from '@carbon/react'
import { chartSeriesHexByIndex } from '@sphere/shared/util'
import styles from './ChartWrapper.module.scss'

export interface BarChartWrapperProps {
  data: Array<Record<string, any>>
  bars: Array<{
    dataKey: string
    name: string
    fill?: string
  }>
  xAxisKey?: string
  title?: string
  height?: number
  yAxisDomain?: [number | string, number | string]
  tooltipFormatter?: (value: any, name: string) => [any, string]
  tooltipLabelFormatter?: (label: any) => string
}

export function BarChartWrapper({
  data,
  bars,
  xAxisKey = 'name',
  title,
  height = 400,
  yAxisDomain,
  tooltipFormatter,
  tooltipLabelFormatter,
}: BarChartWrapperProps) {
  const content = (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xAxisKey} />
        <YAxis domain={yAxisDomain} />
        <Tooltip
          formatter={
            tooltipFormatter as
              | ((value: any, name: string | undefined) => [any, string])
              | undefined
          }
          labelFormatter={tooltipLabelFormatter}
        />
        <Legend />
        {bars.map((bar, index) => (
          <Bar
            key={bar.dataKey}
            dataKey={bar.dataKey}
            fill={bar.fill || chartSeriesHexByIndex(index)}
            name={bar.name}
            radius={[4, 4, 0, 0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  )

  if (title) {
    return (
      <Tile className={styles.chartTile}>
        <h3 className={styles.chartTitle}>{title}</h3>
        {content}
      </Tile>
    )
  }

  return <div className={styles.chartContainer}>{content}</div>
}
